import { UserAttenderStatus } from './enums/user-attenders-status.enum';
import { WebinarType } from './enums/webinar-type.enum';
import { ImageModel } from './image.model';
import { LinkModel } from './link.model';
import { VideoModel } from './video.model';
import { BundleType } from './enums/bundle-type.enum';
import { NodeModel } from './node.model';
import { TaxonomyModel } from './taxonomy.model';
import { ProfileUserDTO } from './profileUserDTO.model';
import { EventInvitationStatus } from './enums/event-invitation-status.enum';
import { FileModel } from './file-model';
import { EventType } from './enums/event-type.enum';
import { ConditionOperator } from './enums/conditional-operator.enum';
import { EntityTypeId } from './enums/entity-type-id.enum';
import { WebinarProviderEnum } from './enums/webinar-provider.enum';

export class WebinarDTO implements NodeModel {
  uuid: string;
  bundle: BundleType;
  entityTypeId: EntityTypeId;
  title: string;
  id: string;
  contentType: string;
  name: string;
  created: string;
  updated: string;
  alias: string;
  active: boolean;
  date: string;
  mediaImage: ImageModel;
  mediaVideo: VideoModel;
  embedVideo: Partial<VideoModel>;
  password: string;
  meetingId: number;
  startUrl: string;
  joinUrl: string;
  playList: LinkModel;
  joinPassword: string;
  description: string;
  customJoinUrl: string;
  isUpcoming: boolean;
  timezone: string;
  duration: number;
  calendarLink: string;
  role: number;
  type: WebinarType;
  relatedEntities: any[];
  attendees: {
    max: number;
    reserved: number;
    waitingList: number;
    currentUserStatus: UserAttenderStatus;
  };
  isConnectedWithProvider: boolean;
  isRegistrationOpen: boolean;
  attendeeManagement: boolean;
  baseType: EventType;
  location?: string;

  mediaFiles?: FileModel[];

  limitParticipants?: {
    enabled: boolean;
    limit: number;
    waitingListEnabled: boolean;
  };
  registrationStart?: {
    enabled: boolean;
    date: Date;
  };

  registrationEnd?: {
    enabled: boolean;
    date: Date;
  };
  
  postEventPoll?: {
    enabled: boolean;
    reference: NodeModel;
  };

  invitationStatus: EventInvitationStatus;

  users: any[];
  lastAttendees?: ProfileUserDTO[];
  collaborativeBoard?: {
    enabled: boolean;
    embeddedContent: string;
  };
  publicTags: TaxonomyModel[];
  provider: WebinarProviderEnum;

  hasOfflineActivity?: boolean;
  offlineActivityId?: string;
  offlineActivityParentId?: string;
  serie: Partial<NodeModel>;

  isCompleteMandatoryContents: boolean;
  mandatoryContents: NodeModel[];
  mandatoryContentsCondition: ConditionOperator;

  isParent: boolean;
  parent?: WebinarDTO;
  contentLanguage?: string;
  childrenAmount?: number;
  completedChild?: WebinarDTO;
  leaderboardPoints: number;
}
